"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiListItemTextOverrides = void 0;
var createMuiListItemTextOverrides = function (_a) {
    var spacing = _a.spacing, typography = _a.typography;
    return ({
        root: {
            padding: spacing(2),
            marginTop: undefined,
            marginBottom: undefined,
        },
        primary: __assign({}, typography.body1),
        secondary: __assign(__assign({}, typography.caption), { lineHeight: 1.25, marginTop: spacing(1) }),
        multiline: {
            marginTop: undefined,
            marginBottom: undefined,
        },
    });
};
exports.createMuiListItemTextOverrides = createMuiListItemTextOverrides;
//# sourceMappingURL=MuiListItemText.js.map